/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/Breadcrumbs/theme';

export const BreadcrumbsTheme = theme;
